<template>
    <div>
        <div class="my-title">
            {{newinfo.title}}
        </div>

        <div v-html="newinfo.content">

        </div>


    </div>
</template>
<script>
import { indexRichtext } from "@/api/index.js";
export default {
    props:{
         checkId:{
            type:Number
        }
    },
    data() {
        return {
            newinfo:{}
        };
    },
    created() {
    this.getIndexRichtext()
    },
    methods: {
        getIndexRichtext(){
            console.log(this.checkId);
        
            indexRichtext({id:this.checkId}).then(res=>{
            console.log(res.data);
            this.newinfo = res.data
            })
        }
    }
};
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/index/help/compontents/orderHelp.vue